<template>
  <div style="height: 100%; width: 100%">
    <div class="d-flex align-center justify-center" style="height: 52px">
      <!-- <v-btn icon="mdi-link-variant" color="faded" variant="text"></v-btn> -->

      <v-btn
        icon="mdi-delete-outline"
        color="faded"
        variant="text"
        size="small"
        @click="
          media = [];
          mode = null;
        "
      ></v-btn>
      <v-btn
        v-if="media.length > 0 && media[0].type === 'image'"
        icon="mdi-image-plus-outline"
        color="faded"
        variant="text"
        size="small"
        @click="$emit('addMedia')"
      ></v-btn>
      <v-btn
        v-if="media[0].type === 'url'"
        icon
        color="faded"
        variant="text"
        size="small"
        @click="openLink(media[0].url)"
        ><v-icon size="small">mdi-open-in-new</v-icon></v-btn
      >
    </div>
    <v-divider></v-divider>

    <div v-if="media[0].extension === 'html'">
      <div ref="htmlContainer" class="html-editor-container">
        <div ref="htmlWrapper" class="html-editor-wrapper">
          <div class="html-editor-canvas" v-html="media[0].html"></div>
        </div>
      </div>
    </div>

    <div
      v-else-if="media?.length > 0 && media[0].type === 'video'"
      style="height: calc(100% - 40px); width: 100%"
      class="pa-2"
    >
      <video
        :src="media[0].src"
        width="100%"
        height="100%"
        autoplay
        muted
        loop
      ></video>
    </div>

    <div
      v-else-if="media && media.length > 0 && media[0].type === 'image'"
      style="height: calc(100% - 40px); width: 100%"
      class="pa-2"
    >
      <v-img
        v-if="media && media.length === 1 && media[0].type !== 'url'"
        :src="media[0].src"
        width="100%"
        contain
      >
        <v-btn
          icon="mdi-delete-outline"
          variant="tonal"
          size="x-small"
          @click="
            media = [];
            mode = null;
          "
          style="position: absolute; top: 10px; right: 10px"
        ></v-btn>
      </v-img>
      <div
        v-else-if="media && media.length === 2 && media[0].type !== 'url'"
        style="display: grid; grid-template-columns: 1fr 1fr; gap: 4px"
      >
        <v-img :src="media[0].src" height="100%" cover>
          <v-btn
            icon="mdi-delete-outline"
            variant="tonal"
            size="x-small"
            @click="media.splice(0, 1)"
            style="position: absolute; top: 10px; right: 10px"
          ></v-btn>
        </v-img>
        <v-img :src="media[1].src" height="100%" cover>
          <v-btn
            icon="mdi-delete-outline"
            variant="tonal"
            size="x-small"
            @click="media.splice(1, 1)"
            style="position: absolute; top: 10px; right: 10px"
          ></v-btn>
        </v-img>
      </div>
      <div v-else-if="media && media.length > 2" class="media-multi">
        <div
          class="media-hero"
          style="display: grid; grid-template-columns: 2fr 1fr; gap: 3px"
        >
          <v-img :src="media[0].src" cover>
            <v-btn
              icon="mdi-delete-outline"
              variant="tonal"
              size="x-small"
              @click="removeMedia(0)"
              style="position: absolute; top: 10px; right: 10px"
            />
          </v-img>
          <div class="d-flex flex-column" style="gap: 4px">
            <v-img :src="media[1].src" cover>
              <v-btn
                icon="mdi-delete-outline"
                variant="tonal"
                size="x-small"
                @click="removeMedia(1)"
                style="position: absolute; top: 10px; right: 10px"
              />
            </v-img>
            <v-img :src="media[2].src" cover>
              <v-btn
                icon="mdi-delete-outline"
                variant="tonal"
                size="x-small"
                @click="removeMedia(2)"
                style="position: absolute; top: 10px; right: 10px"
              />
            </v-img>
          </div>
        </div>
        <div
          v-if="media.length > 3"
          class="media-rest"
          style="
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
            gap: 4px;
            margin-top: 4px;
          "
        >
          <v-img
            v-for="(m, i) in media.slice(3)"
            :key="i"
            :src="m.src"
            cover
            aspect-ratio="1"
          >
            <v-btn
              icon="mdi-delete-outline"
              variant="tonal"
              size="x-small"
              @click="removeMedia(3 + i)"
              style="position: absolute; top: 4px; right: 4px"
            />
          </v-img>
        </div>
      </div>
    </div>

    <div
      v-else-if="media && media.length === 1 && media[0].type === 'url'"
      class="pa-2"
    >
      <v-img
        v-if="media[0].thumbnail || media[0].src"
        :src="media[0].thumbnail || media[0].src"
        max-width="100%"
        cover
        style="border-radius: 4px"
        class="mb-2"
      ></v-img>
      <div style="flex: 1">
        <p
          style="
            font-size: 10pt;
            font-weight: 600;
            margin: 0;
            color: #191919;
            letter-spacing: 0.01em;
          "
        >
          {{ media[0].title || "Link Preview" }}
        </p>
        <p
          style="
            font-size: 9pt;
            margin: 0;
            color: #666666;
            margin-top: 4px;
            letter-spacing: 0.01em;
          "
        >
          {{ media[0].description || "No description available" }}
        </p>
        <p
          style="
            font-size: 8pt;
            margin: 0;
            color: #666666;
            margin-top: 4px;
            letter-spacing: 0.01em;
          "
        >
          {{ getDomain(media[0]?.url) }}
        </p>
      </div>
    </div>

    <div
      v-else-if="media && media.length === 1 && media[0]?.extension === 'pdf'"
      style="max-height: 500px; overflow: auto"
    >
      <VuePdfEmbed :source="media[0]?.src" height="500" />
    </div>
  </div>
</template>

<script>
import { post } from "@/mixins/post";
import VuePdfEmbed from "vue-pdf-embed";

export default {
  mixins: [post],
  components: {
    VuePdfEmbed,
  },
  data() {
    return {
      htmlResizeObserver: null,
    };
  },
  mounted() {
    this.initHtmlResizeObserver();
  },
  beforeUnmount() {
    if (this.htmlResizeObserver) {
      this.htmlResizeObserver.disconnect();
      this.htmlResizeObserver = null;
    }
  },
  methods: {
    removeMedia(index) {
      this.media.splice(index, 1);
      if (this.media.length === 0) {
        this.mode = null;
      }
    },
    getDomain(url) {
      if (!url) return "";
      try {
        const domain = new URL(url).hostname;
        return domain.replace("www.", "");
      } catch {
        return url;
      }
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    initHtmlResizeObserver() {
      const container = this.$refs.htmlContainer;
      const wrapper = this.$refs.htmlWrapper;
      if (!container || !wrapper) return;

      const baseWidth = 1080; // base canvas width
      const updateScale = () => {
        const width = container.offsetWidth || 0;
        if (!width) return;
        const scale = Math.min(width / baseWidth, 1);
        wrapper.style.setProperty("--html-scale", scale.toString());
      };

      this.htmlResizeObserver = new ResizeObserver(updateScale);
      this.htmlResizeObserver.observe(container);
      this.$nextTick(updateScale);
    },
  },
};
</script>

<style scoped>
.html-editor-container {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.html-editor-wrapper {
  transform-origin: top center;
  transform: scale(var(--html-scale, 1));
  /* base 1200px canvas; controls height so there is no extra whitespace */
  height: calc(1080px * var(--html-scale, 1));
}

.html-editor-canvas {
  width: 1080px;
  height: 1080px;
}

.html-editor-canvas :deep(.screenshot) {
  width: 100%;
  height: 100%;
}
</style>
